/**
 * Description: 输入框
 * User: 常胤 <satans17@gmail.com>
 * Date: 15/11/8
 * Copyright(c) 2014 Taobao.com
 */

import events from 'events';
import $ from '@ali/tarzan-zepto';
import Utils from '../../../../../lib/util';
import Tip from '../../tip/index';
import { AGENT_MOD } from '../../../../../const/objects.const';

export default class Field extends events {

  constructor(config) {
    super();
    this.elementSelectors = {
      inputFormWrapperId: '#alime-input-form-wrapper',
      inputTextWrapperId: '#alime-input-text-wrapper',
    };
    this.textInputDefaultHeight = 36;
    this.textInputMaxHeight = 66;
    this.textInputWrapperPadding = 14;
    const { inputTextWrapperId } = this.elementSelectors;

    const $target = $(config.trigger);
    /**
     * 输入对象
     */
    this.$field = $target;
    this.$container = config.$container;
    this.$copy = this.$field.siblings('.J_InputFieldCopy');// 多行输入框 copy里面的内容
    this.$numberField = this.$field.siblings('.J_NumberField');// 数字输入框
    this.$wrap = this.$container.find(inputTextWrapperId);
    /**
     * 输入框类型
     * @type {string}
     */
    this.inputFormat = 'text';
    this.textInputHeight = 0;
    this.__bindEvt();
    this.__hack();
  }

  /**
   * 设置textarea的值
   * @param {any}
   * @memberOf Field
   */
  setValue(val) {
    const f = this.$field;
    const old = f.val();
    this.$field.val(val);
    this.$numberField.val(val);
    this.__valueChange(val, old);
  }

  getValue() {
    return this.$field.val();
  }

  /**
   * 设置输入框类型, 比如 text(默认)  number数字
   * @param type
   */
  switchInputFormat(type = 'text') {
    if (type === 'number') {
      this.$field.hide();
      this.$numberField.show();
    } else {
      this.$numberField.hide();
      this.$field.show();
    }
    this.inputFormat = type;
  }

  /**
   * 在光标处插入内容
   * @param text
   */
  insertVal(text) {
    const el = this.$field[0];
    const val = el.value;
    let endIndex;
    let range;
    // 前者为chrome等浏览器下解决方案，else里为IE下解决方案
    if (
      typeof el.selectionStart !== 'undefined' &&
      typeof el.selectionEnd !== 'undefined'
    ) {
      endIndex = el.selectionEnd;
      el.value = val.slice(0, el.selectionStart) + text + val.slice(endIndex);
      el.selectionStart = el.selectionEnd = endIndex + text.length;
      // 这里更改selectionStart会自动focus文本框
      this.blur();
    } else if (
      typeof document.selection !== 'undefined' &&
      typeof document.selection.createRange !== 'undefined'
    ) {
      // 输入表情的时候不唤起键盘
      // el.focus();
      range = document.selection.createRange();
      range.collapse(false);
      range.text = text;
      range.select();
    }
    this.__valueChange(el.value, val);
  }

  /**
   * 获取焦点
   * @memberOf Field
   */
  focus() {
    setTimeout(() => {
      this.$field[0].focus();
    }, 200);
  }

  /**
   * 失去焦点
   * @memberOf Field
   */
  blur() {
    this.$field[0].blur();
  }

  /**
   * 自动调整输入框
   * @memberOf Field
   */
  adjustTextareaHeight() {
    const val = this.$field.val();
    const invisibleTextarea = this.$copy;
    invisibleTextarea.val(val);
    const height = invisibleTextarea[0].scrollHeight;
    this.setTextareaHeight(Math.max(height, this.textInputDefaultHeight));
  }

  setTextareaHeight(height) {
    // create restriction for height max 120px
    if (height > this.textInputMaxHeight || this.textInputHeight === height) {
      return;
    }
    const { inputFormWrapperId, inputTextWrapperId } = this.elementSelectors;
    const $formWrapper = $(inputFormWrapperId);
    const $textWrapper = $(inputTextWrapperId);
    this.textInputHeight = height;

    if ($formWrapper.hasClass(AGENT_MOD)) {
      console.log('show agent style');
    } else {
      $formWrapper.height(height + this.textInputWrapperPadding);
    }
    $textWrapper.height(height);
    this.$field.height(height);
    $textWrapper.parents('#alime-input-form-wrapper.-mobile').height(height + 14);
    this.emit('resize');
  }

  /**
   * 设置placeholder
   * @param text
   */
  setPlaceholder(text) {
    this.$field.attr('placeholder', text);
  }

  __valueChange(newVal, oldVal) {
    this.adjustTextareaHeight();
    this.emit('input', {
      newVal,
      oldVal,
    });
  }

  __bindEvt() {
    const f = this.$field;
    let text = '';
    // 给数字键盘绑定事件,值变化之后,同步设置textarea的值,并触发textarea的change事件
    this.$numberField.on('keydown keyup change input', Utils.buffer(() => {
      this.$field.val(this.$numberField.val());
      f.trigger('change');
    }, 100));

    f.on('focus', () => {
      this.$wrap.addClass('active');
    }).on('blur', () => {
      this.$wrap.removeClass('active');
    });

    f.on('keydown keyup change input', Utils.buffer(() => {
      const newText = f.val();
      const LIMIT = 300;
      if (newText.trim().length > LIMIT) {
        f.val(newText.trim().substr(0, LIMIT - 1));
        this.showTips('Your input exceeds the limit', 3000);
      }
      this.__valueChange(f.val(), text);
      text = newText;
    }));
  }
  /**
   * ios键盘顶起hack
   * @memberOf Field
   */
  __hack() {
    const $f = this.$field;
    const f = this.$field[0];

    // 输入框在ios下被输入法挡住的问题
    if (Utils.UA.ios && f.scrollIntoView) {
      let timer = null;
      $f.on('focus', () => {
        timer = setInterval(() => {
          f.scrollIntoView(false);
        }, 50);
      }).on('blur', () => {
        if (timer) {
          clearInterval(timer);
        }
      });
    }
  }

  /**
   * 输入报错提示
   * @param {any} content
   * @param {any} time
   * @memberOf Field
   */
  showTips(content, time) {
    this.tip = new Tip({
      content,
      interval: time,
    });
  }
}



// WEBPACK FOOTER //
// ./src/component/view/footer/input/field/index.js